export const filterChannelList = (
  customerChannelList: any,
  selectedMov: any
) : any[] => {
  let newCustomerChannelList = [...customerChannelList];
  let abc: any = [];
  customerChannelList.forEach((d: any, index: number) => {
    if (selectedMov.current.some((e: any) => e.title == d.title)) {
      abc.push(index);
    }
  });
  newCustomerChannelList = newCustomerChannelList.filter(
    (value: number, index: number) => abc.indexOf(index) === -1
  );
  return newCustomerChannelList;
};
